import axios from 'axios';

import { formattedMoney, millionFormattedtoString, numberToKorean } from '~utils/formatted/number';
import { isClient } from '~utils/lodash/isServer';

export interface BookmarkData {
  AVG_SALARY_FINAL: number;
  CMPN_NM: string;
  COMPANY_AGE: number;
  ID: number;
  PK_NM_HASH: string;
  PRSN_BASE: number;
  PRSN_DIF_RATIO: number;
  PRSN_IN_RATIO: number;
  PRSN_OUT_RATIO: number;
  SALARY_SALES_RATIO: number;
  SALES_PER_MAN: number;
  FOUND_YEAR: number;
  SALES_VALUE: number;
}

export function getBookmarksAtLocal() {
  if (!isClient) {
    return [];
  }

  const localData = window.localStorage.getItem('kjbasket');

  if (!localData) {
    return [];
  }

  return JSON.parse(localData);
}

export function updateBookmarksAtLocal(bookmarks: string[]) {
  if (isClient) {
    window.localStorage.setItem('kjbasket', JSON.stringify(bookmarks));
  }
}

export function getBookmarks({ bookmarks }: { bookmarks: string[] }) {
  return axios.post<{ data: BookmarkData[] }>('/api/company/basket', {
    PK_NM_HASH: bookmarks,
  });
}

export function getPercentage(percentage: number, fixed?: number) {
  const value = percentage * 100;

  return value.toFixed(fixed);
}

export function displayPercentage(value?: number | 'BLOCK') {
  if (value === 'BLOCK') return '비공개';

  return !value ? '-' : `${getPercentage(value, 1)}%`;
}

export function displayNumberToKorean(value?: number | 'BLOCK') {
  if (value === 'BLOCK') return '비공개';

  return !value ? '-' : `${numberToKorean(value, 'total')}`;
}

export function displaySalaryAvg(value?: number | 'BLOCK') {
  if (value === 'BLOCK') return '비공개';

  return !value ? '-' : `${millionFormattedtoString(value)}만원`;
}

export function displayEmployee(value?: number | 'BLOCK') {
  if (value === 'BLOCK') return '비공개';

  return !value ? '-' : `${formattedMoney(value)}명`;
}
